import { FC, useContext } from 'react';
import { Box, Typography, Fade, Paper, Avatar } from '@mui/material';
import { UserContext } from '@modules/Users/contexts';

interface Props {
  assertion: Assertions.Assertion;
  isFront?: boolean;
  assertionImage: Assertions.AssertionImage;
}

export const AssertionCard: FC<Props> = ({ assertion, isFront = true, assertionImage }) => {
  const { user } = useContext(UserContext);

  return (
    <Fade in>
      <Box position="relative" variant="elevation" elevation={isFront ? 2 : 0} component={Paper} width="100%" height="100%" overflow="hidden">
        <Box
          height="100%"
          width="100%"
          sx={{
            backgroundImage: `url(${assertionImage.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
          aria-label={assertion.content}
        />
        {/* Scrim/overlay for better readability */}
        <Fade in={isFront}>
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            sx={{
              pointerEvents: 'none',
            }}
          />
        </Fade>
        {/* Centered text */}
        <Fade in={isFront}>
          <Box
            position="absolute"
            width="100%"
            bottom={0}
            sx={{
              zIndex: 2,
            }}
            p={3}
          >
            <Box position="relative" pb={6}>
              <Box className="speech-bubble arrow">
                <Typography
                  variant="body1"
                  align="center"
                  fontSize={24}
                  sx={{ transform: 'rotate(2deg) rotateY(-15deg)' }}
                >
                  {assertion.content}
                </Typography>
              </Box>
              <Box
                left="80%"
                display="flex"
                justifyContent="flex-end"
                pt={1}
              >
                <Avatar
                  alt={user?.displayName}
                  src={user?.profilePicture}
                  sx={{
                    width: 56,
                    height: 56,
                    borderColor: '#000',
                    borderStyle: 'solid',
                    borderWidth: 2,
                    boxShadow: '-3px 3px 0 #000',
                    backgroundColor: 'background.default',
                    color: 'secondary.dark',
                  }}
                >
                  <Typography variant="body1" fontWeight={600}>you</Typography>
                </Avatar>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Box>
    </Fade>
  );
};
